import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { PAGE_PATHS } from "@/constants";
import { cn } from "@/lib/utils";

interface LogoProps {
  /** Yig'ilgan sidebar'da faqat belgi ko'rsatiladi. */
  collapsed?: boolean;
  className?: string;
}

/**
 * "Learn up" so'z belgisi + "Admin" izohi.
 *
 * Ranglar yon panel tokenlaridan olinadi, shuning uchun logotip yorug' va
 * qorong'i mavzuda ham, mobil sheet ichida ham bir xil o'qiladi.
 */
export const Logo = ({ collapsed = false, className }: LogoProps) => {
  const { t } = useTranslation();

  return (
    <Link
      to={PAGE_PATHS.DASHBOARD}
      aria-label={t("NAV.GO_TO_DASHBOARD")}
      className={cn("font-heading flex min-w-0 shrink-0 items-center gap-2", className)}
    >
      <span className="bg-sidebar-primary text-sidebar-primary-foreground grid size-8 shrink-0 place-items-center rounded-lg text-sm font-bold">
        L
      </span>
      {!collapsed && (
        <span className="text-sidebar-foreground truncate text-sm font-semibold tracking-tight">
          Learn up <span className="text-muted-foreground font-normal">Admin</span>
        </span>
      )}
    </Link>
  );
};
